import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import type { ReportService } from '~/api/services/types'
import type { PaginationParams } from '~/types/pagination'
import type { PaginatedReport, ReportEncodingType, ReportNamespace, ReportPayload, ReportType } from '~/types/report'

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): ReportService => {
  return {
    generateReport: async (
      payload: ReportPayload,
      namespace: ReportNamespace,
      type: ReportType,
      pagination: PaginationParams,
      encoding: ReportEncodingType = 'application/json'
    ): Promise<PaginatedReport | BlobPart> => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.REPORTS_GENERATE,
        {
          headers: {
            Accept: encoding
          },
          queryParams: {
            current_page: pagination.current_page,
            per_page: pagination.per_page,
            ...(pagination.sort && { sort: pagination.sort })
          },
          params: {
            namespace,
            type
          }
        },
        { ...payload }
      )
      return await client<PaginatedReport | BlobPart>(url, {
        method,
        headers,
        body,
        ...(encoding === 'application/json' ? {} : { responseType: 'blob' as const })
      })
    }
  }
}
